/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCapexVariantDto } from '../../models/backend-capex-variant-dto';
import { BackendCapexVariantRequestDto } from '../../models/backend-capex-variant-request-dto';

export interface EconomicIndicatorsCapexVariantsUpdate$FormData$Params {
  /**
   * A unique integer value identifying this capex variant.
   */
  id: number;
  body: BackendCapexVariantRequestDto;
}

export function economicIndicatorsCapexVariantsUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: EconomicIndicatorsCapexVariantsUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCapexVariantDto>> {
  const rb = new RequestBuilder(rootUrl, economicIndicatorsCapexVariantsUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCapexVariantDto>;
    }),
  );
}

economicIndicatorsCapexVariantsUpdate$FormData.PATH = '/api/economic_indicators/capex_variants/{id}/';
